import { render, staticRenderFns } from "./forex-gpd-chart.vue?vue&type=template&id=3722396e&scoped=true&"
import script from "./forex-gpd-chart.vue?vue&type=script&lang=js&"
export * from "./forex-gpd-chart.vue?vue&type=script&lang=js&"
import style0 from "./forex-gpd-chart.vue?vue&type=style&index=0&id=3722396e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3722396e",
  null
  
)

export default component.exports